var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total-block"},[(_vm.label)?_c('div',{staticClass:"total-block__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"flex flex-direction gap total-block__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }